module.exports = __webpack_public_path__ + "img/6.0d1c493c.png";